export default function mixSDKData(getters) {
  const data = {};
  const subs = [];
  for (const key in getters) {
    const getState = getters[key];
    const { state: _state } = getState();
    data[key] = _state;
  }
  const mixin = {
    data() {
      return data;
    },
    mounted() {
      for (const key in getters) {
        const getState = getters[key];
        const { state$ } = getState();
        const subscription = state$
          .subscribe((v) => {
            this[key] = v;
          });
        subs.push(subscription);
      }
    },
    unmounted() {
      subs.forEach(sub => {
        sub.unsubscribe();
      });
    },
  };
  return mixin;
}